"use client"

import * as React from "react"
import {
  LayoutDashboard,
  TrendingUp,
  Settings,
  Users,
  FileText,
  BarChart3,
  Database,
  Home,
} from "lucide-react"

import { NavMain } from "components/nav-main"
import { NavUser } from "components/nav-user"
import { useAuth } from "contexts/AuthContext"

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from "components/ui/sidebar"

import type { MenuPermission } from "api/auth"

interface MenuItem {
  title: string
  url: string
  icon: any
  items?: MenuItem[]
}


const iconMap: Record<string, any> = {
  LayoutDashboard,
  TrendingUp,
  Settings,
  Users,
  FileText,
  BarChart3,
  Database,
  Home,
}

const findIcon = (name: string) => iconMap[name] || LayoutDashboard

const convertMenuTree = (menu: MenuPermission): MenuItem => ({
  title: menu.menu_desc,
  url: menu.route_path || "#",
  icon: findIcon(menu.icon_name),
  items: (menu.submenu || []).map(convertMenuTree),
})


export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { user, menuPermissions } = useAuth()

  const displayName = (user as any)?.full_name || (user as any)?.name || "User"
  const displayEmail = (user as any)?.email || ""

  // Convert backend menu permissions to sidebar structure
  const finalMenu: MenuItem[] = React.useMemo(() => {
    if (!menuPermissions || menuPermissions.length === 0) return []
    return menuPermissions.map(convertMenuTree)
  }, [menuPermissions])

  return (
    <Sidebar collapsible="offcanvas" {...props}>
      <SidebarHeader>
        <div className="flex items-center gap-2 px-2 py-2">
          <img src="/logo.png" alt="MRC MIS" width={150} height={150} />
        </div>
      </SidebarHeader>

      <SidebarContent>
        <NavMain items={finalMenu} />
      </SidebarContent>

      <SidebarFooter>
        <NavUser user={{ name: displayName, email: displayEmail }} />
      </SidebarFooter>

      <SidebarRail />
    </Sidebar>
  )
}
